import Controller from '@ember/controller';
import { isPresent, isBlank } from '@ember/utils';
import { inject as service } from '@ember/service';
import { or } from 'macro-decorators';
export default class EmployeesController extends Controller {
  @service currentAdmin;
  @service featureFlags;
  @service visitorsOnboarding;
  @service emptyStatePage;

  @or('currentAdmin.isGlobalAdmin', 'currentAdmin.isLocationAdmin') isAdmin;

  get isRouteCurrentOnboardingStep() {
    const {
      visitorsOnboarding: { currentRouteStep, currentStep },
    } = this;
    return isPresent(currentRouteStep) && currentRouteStep === currentStep;
  }

  get nextStartedStep() {
    const { currentRouteStep, steps } = this.visitorsOnboarding;
    let idx = steps.indexOf(currentRouteStep) + 1;
    for (idx; idx < steps.length; idx++) {
      const step = steps.objectAt(idx);
      if (step.started) {
        return step;
      }
    }
    return undefined;
  }

  get shouldShowOnboardingStepper() {
    const {
      isRouteCurrentOnboardingStep,
      nextStartedStep,
      visitorsOnboarding: { currentRouteStep },
    } = this;
    const isCurrentRouteStepDone = isPresent(currentRouteStep) && currentRouteStep.done;
    if (isRouteCurrentOnboardingStep) {
      return !isCurrentRouteStepDone;
    }
    return isCurrentRouteStepDone && isBlank(nextStartedStep);
  }

  get showSetupGuide() {
    return (
      this.isAdmin &&
      !this.emptyStatePage.shouldShowEmployeeDirectoryEmptyPage &&
      this.featureFlags.isEnabled('growth_show_visitors_setup_guide_stepper')
    );
  }
}
